// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HelpMessageCard_wrap__wyVX9","titleWrap":"HelpMessageCard_titleWrap__2PWVF","linkText":"HelpMessageCard_linkText__Zpk84"};